<template>
	<b-notification type="is-primary" :closable="false" v-if="selectedMemberType">
		<p class="is-size-4">
			<b>You have selected:</b>
		</p>
		<p>
			Member Type - <strong>{{ displayTypeDetails.type }}</strong>
		</p>
		<p>
			NHS Medical - <strong>{{ displayTypeDetails.nhsMedical }}</strong>
		</p>
		<p>
			Non Clinical Scientist -
			<strong>{{ displayTypeDetails.nonClinical }}</strong>
		</p>
		<p>
			NHS - <strong>{{ displayTypeDetails.nhs }}</strong>
		</p>
		<p>
			Price - <strong>{{ displayTypeDetails.price }}</strong> per year
		</p>
	</b-notification>
</template>

<script>
export default {
	name: 'SelectedMemberNotification',

	props: {
		selectedMemberType: {
			type: String,
			required: false,
		},
	},

	data() {
		return {
			typeDetails: {},
		};
	},

	computed: {
		displayTypeDetails() {
			// Copy the Return Objects from the ApplicationForm component data section (or vice-versa)
			switch (this.selectedMemberType) {
				case 'Reduced':
					return {
						type: 'Reduced',
						nhsMedical: 'Student',
						nonClinical: 'Scientist',
						nhs: 'Band 7 and Below',
						price: '£40.00',
					};
				case 'Ordinary':
					return {
						type: 'Ordinary',
						nhsMedical: 'SPR',
						nonClinical: 'Lecturer',
						nhs: 'Band 8a, 8b or 8c',
						price: '£105.00',
					};
				case 'Consultant':
					return {
						type: 'Consultant',
						nhsMedical: 'Consultant',
						nonClinical: 'Senior Lecturer, Reader, Professor',
						nhs: 'Band 8d or above',
						price: '£150.00',
					};
				default:
					return null;
			}
		},
	},
};
</script>

<style></style>
